export enum ArrowKinds {
  None = 1,
  ArrowFrom = 2,
  ArrowTo = 3,
  ArrowBoth = 4
}
